__turbopack_context__.v({
  "alertsTitle": "digestAlerts-module-scss-module__a5nH4G__alertsTitle",
  "container": "digestAlerts-module-scss-module__a5nH4G__container",
  "title": "digestAlerts-module-scss-module__a5nH4G__title",
});
